<p-dialog
  header="Add Tokens"
  [modal]="true"
  [draggable]="false"
  [style]="{ width: 'min(32rem, 96vw)' }"
  [breakpoints]="{ '575px': '96vw' }"
  appendTo="body"
  [(visible)]="visible"
  [closable]="!saving"
  [closeOnEscape]="!saving"
  (onShow)="onDialogShow()"
>
  <p class="m-0 mb-4 text-sm text-surface-switch-600">
    Allocate complimentary or customer-purchase tokens to this tenant. Tokens
    will be available between the valid from and valid to dates.
  </p>

  <div class="flex flex-col gap-4">
    <div class="flex flex-col gap-1.5">
      <label for="add-tokens-allocation-type" class="text-sm font-medium"
        >Allocation type</label
      >
      <p-select
        inputId="add-tokens-allocation-type"
        [options]="allocationTypeOptions"
        [(ngModel)]="allocationType"
        optionLabel="label"
        optionValue="value"
        placeholder="Select allocation type"
        class="w-full"
        appendTo="body"
      />
    </div>

    <div class="flex flex-col gap-1.5">
      <label for="add-tokens-type" class="text-sm font-medium"
        >Token type</label
      >
      <p-select
        inputId="add-tokens-type"
        [options]="tokenTypeOptions"
        [(ngModel)]="tokenType"
        optionLabel="label"
        optionValue="value"
        placeholder="Select token type"
        class="w-full"
        appendTo="body"
      />
    </div>

    <div class="flex flex-col gap-1.5">
      <label for="add-tokens-amount" class="text-sm font-medium"
        >Number of tokens</label
      >
      <p-inputNumber
        inputId="add-tokens-amount"
        [(ngModel)]="allocatedAmount"
        [showButtons]="true"
        [min]="1"
        class="w-full"
        inputStyleClass="w-full"
      />
    </div>

    <div class="flex flex-col gap-1.5">
      <label for="add-tokens-valid-from" class="text-sm font-medium"
        >Valid from</label
      >
      <p-datepicker
        inputId="add-tokens-valid-from"
        [(ngModel)]="validFrom"
        dateFormat="yy-mm-dd"
        showIcon
        appendTo="body"
        class="w-full"
        inputStyleClass="w-full"
      />
    </div>

    <div class="flex flex-col gap-1.5">
      <label for="add-tokens-valid-to" class="text-sm font-medium"
        >Valid to</label
      >
      <p-datepicker
        inputId="add-tokens-valid-to"
        [(ngModel)]="validTo"
        dateFormat="yy-mm-dd"
        showIcon
        appendTo="body"
        class="w-full"
        inputStyleClass="w-full"
      />
    </div>

    @if (validFrom && validTo && validTo <= validFrom) {
      <p class="m-0 text-sm text-red-500">Valid to must be after valid from.</p>
    }
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-2 pt-2">
      <p-button
        label="Cancel"
        severity="secondary"
        [disabled]="saving"
        (onClick)="close()"
      />
      <p-button
        label="Add tokens"
        icon="pi pi-plus"
        [disabled]="!canSave || saving"
        [loading]="saving"
        (onClick)="save()"
      />
    </div>
  </ng-template>
</p-dialog>
